export default {
  namespaced: true,
  state: {
    initialized: false,
    user: {}
  },
  mutations: {
    setUser(state, payload) {
      state.user = {
        uid: payload.user.uid,
        email: payload.user.email
      };
      state.initialized = true;
    },
    clearUser(state) {
      state.user = {};
      state.initialized = true;
    }
  },
  actions: {
    setUser(context, payload) {
      context.commit("setUser", payload);
    },
    clearUser(context) {
      context.commit("clearUser");
    }
  },
  getters: {
    user(state) {
      return state.user;
    },
    init(state) {
      return state.initialized;
    }
  }
};
